import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, Stack, Button, Tooltip, IconButton } from '@mui/material';
//
import Iconify from './Iconify';
import Image from 'src/components/Image';
import { styled } from '@mui/styles';
// ----------------------------------------------------------------------

SocialsButton.propTypes = {
  initialColor: PropTypes.bool,
  links: PropTypes.objectOf(PropTypes.string),
  simple: PropTypes.bool,
  sx: PropTypes.object,
};

export default function SocialsButton({ initialColor = false, simple = true, links = {}, sx, ...other }) {
  const SOCIALS = [
    {
      name: 'Google',
      icon: '/images/footer/google.png',
      socialColor: '#1877F2',
      path: links.google || '#google-link',
      width: '100%',
      height: '100%'
    },
    {
      name: 'FaceBook',
      icon: '/images/footer/facebook.png',
      socialColor: '#1877F2',
      path: links.facebook || '#facebook-link',
      width: '100%',
      height: '100%'
    },

    {
      name: 'Linkedin',
      icon: '/images/footer/linkedin.png',
      socialColor: '#007EBB',
      path: links.linkedin || '#linkedin-link',
      width: '100%',
      height: '100%'
    },
  ];

  const CustomImage = styled(Image)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      width: '35.56px',
      height: '35.56px'
    }
  }));
  return (
    <Stack direction="row" flexWrap="wrap" alignItems="center">
      {SOCIALS.map((social) => {
        const { name, icon, path, socialColor, width, height } = social;
        return simple ? (
          <Link key={name} href={path}>
            <Tooltip title={name} placement="top">
              <IconButton
                color="inherit"
                sx={{
                  ...(initialColor && {
                    color: socialColor,
                    '&:hover': {
                      bgcolor: alpha(socialColor, 0.08),
                    },
                  }),
                  ...sx,
                }}
                {...other}
              >
                <CustomImage
                  key={icon}
                  alt={name}
                  src={icon}
                  sx={{
                    width: width,
                    height: height,
                  }}
                />
                {/* <Iconify icon={icon} sx={{ width: 20, height: 20 }} /> */}
              </IconButton>

            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            href={path}
            color="inherit"
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0,
              flexShrink: 0,
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha(socialColor, 0.08),
                },
              }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
